import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { BadgeComponent } from '../../badge/badge/badge.component';
import { EuroCurrencyPipe } from '@mwe/ui/pipes';
import { TranslatePipe } from '@ngx-translate/core';
import { InvoiceStatusConfig } from '@mwe/models';

@Component({
  selector: 'mwe-invoice-amount-and-status',
  templateUrl: './invoice-amount-and-status.component.html',
  imports: [BadgeComponent, EuroCurrencyPipe, TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InvoiceAmountAndStatusComponent {
  priceColor = input.required<string>();
  invoiceAmount = input.required<number>();
  invoiceStatusConfig = input.required<InvoiceStatusConfig>();
  hasMinusForCreditValues = input<boolean>();
  priceTextClass = input<string>('text-md-end');
  isCredit = computed<boolean>(() => !!this.priceColor()?.length);
  amount = computed<number>(() =>
    this.hasMinusForCreditValues() && this.isCredit() ? this.getNegativeAmount(this.invoiceAmount()) : this.invoiceAmount(),
  );

  private getNegativeAmount(amount: number): number {
    if (!amount) return null;
    return Math.abs(amount) * -1;
  }
}
